var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-written box-shadow-small border-radius"
  }, [_c('p', {
    staticClass: "mt-10 mb-20"
  }, [_c('router-link', {
    attrs: {
      "to": "/written"
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v("返回笔试列表")])], 1), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "mt-20",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 100
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考试标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.ruleForm.title),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "考生须知",
      "prop": "examRules"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 6
      },
      "resize": "none",
      "maxlength": 1000
    },
    model: {
      value: (_vm.ruleForm.examRules),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "examRules", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.examRules"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择笔试题",
      "prop": "paperIds"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(_vm.ruleForm.paperIds.length === 0) ? _c('el-button', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("预览试卷")]) : (_vm.ruleForm.paperIds.length === 1) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.showPage(_vm.ruleForm.paperIds[0])
      }
    }
  }, [_vm._v("\n                            预览试卷\n                        ")]) : _c('el-dropdown', [_c('el-button', {
    attrs: {
      "disabled": _vm.ruleForm.paperIds.length === 0
    }
  }, [_vm._v("\n                                预览试卷"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.ruleForm.paperIds), function(item, index) {
    return _c('el-dropdown-item', {
      key: index,
      nativeOn: {
        "click": function($event) {
          return _vm.showPage(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.getExamName(+item)) + "\n                                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "padding-right": "20px"
    }
  }, [_c('el-select', {
    staticClass: "mb-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "medium",
      "multiple": ""
    },
    model: {
      value: (_vm.ruleForm.paperIds),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "paperIds", $$v)
      },
      expression: "ruleForm.paperIds"
    }
  }, _vm._l((_vm.examLists), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "pick-exam-time",
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考试日期",
      "required": ""
    }
  }, [_c('el-date-picker', {
    ref: "startDate",
    attrs: {
      "type": "date",
      "placeholder": "考试日期",
      "size": "medium",
      "editable": false,
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.ruleForm.beginDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "beginDate", $$v)
      },
      expression: "ruleForm.beginDate"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-10 color-gray"
  }, [_vm._v("考试时长 "), _c('strong', [_vm._v(_vm._s(_vm.durationTime))]), _vm._v(" 分钟，可安排多个时段，考生需提前选择一个时段")])], 1), _vm._v(" "), _vm._l((_vm.ruleForm.timeDotArr), function(item, index) {
    return [_c('el-form-item', {
      staticClass: "time-dot",
      attrs: {
        "prop": 'timeDotArr.' + index + '.startTimeDot',
        "rules": {
          required: true,
          message: '开始时间点不能为空',
          trigger: 'blur'
        },
        "label": ("时间段 " + (index + 1))
      }
    }, [_c('el-time-select', {
      attrs: {
        "size": "medium",
        "picker-options": item.pickerOptions,
        "editable": false,
        "clearable": false,
        "placeholder": "选择开始时间点"
      },
      on: {
        "change": function($event) {
          return _vm.changeTimeDot(item, index)
        }
      },
      model: {
        value: (item.startTimeDot),
        callback: function($$v) {
          _vm.$set(item, "startTimeDot", $$v)
        },
        expression: "item.startTimeDot"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ml-10"
    }, [_c('span', {
      staticClass: "color-gray mr-5"
    }, [_vm._v("——")]), _vm._v(" 结束时间：\n                            "), _c('span', {
      staticClass: "end-time-holder"
    }, [_vm._v(_vm._s(item.endTimeDot))]), _vm._v(" "), (index === 0) ? _c('el-button', {
      attrs: {
        "icon": "el-icon-my-xinjian",
        "type": "text"
      },
      on: {
        "click": _vm.addTimeDot
      }
    }) : _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removeTimeDot(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-my-shanchu color-danger"
    })])], 1)], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.lists
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "候选人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.name) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.phone) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.positionName) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历来源",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeSource) || '-') + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeItem(scope.row.id)
            }
          }
        }, [_vm._v("移除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-10"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelAndBack
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.idsLength === 0
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确认安排")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb62d35e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/writtenArrangement.vue
// module id = null
// module chunks = 